'use strict';

var _regeneratorRuntime = require("/vercel/path0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator");

var _asyncToGenerator = require("/vercel/path0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/asyncToGenerator");

var _classCallCheck = require("/vercel/path0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/vercel/path0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var _inherits = require("/vercel/path0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

var _createSuper = require("/vercel/path0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createSuper");

var IdentityProvider = require('./identity-provider-interface');

var Keystore = require('orbit-db-keystore');

var type = 'orbitdb';

var OrbitDBIdentityProvider = /*#__PURE__*/function (_IdentityProvider) {
  _inherits(OrbitDBIdentityProvider, _IdentityProvider);

  var _super = _createSuper(OrbitDBIdentityProvider);

  function OrbitDBIdentityProvider(keystore) {
    var _this;

    _classCallCheck(this, OrbitDBIdentityProvider);

    _this = _super.call(this);

    if (!keystore) {
      throw new Error('OrbitDBIdentityProvider requires a keystore');
    }

    _this._keystore = keystore;
    return _this;
  } // Returns the type of the identity provider


  _createClass(OrbitDBIdentityProvider, [{
    key: "getId",
    value: function () {
      var _getId = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
        var options,
            id,
            keystore,
            key,
            _args = arguments;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                options = _args.length > 0 && _args[0] !== undefined ? _args[0] : {};
                id = options.id;

                if (id) {
                  _context.next = 4;
                  break;
                }

                throw new Error('id is required');

              case 4:
                keystore = this._keystore;
                _context.next = 7;
                return keystore.getKey(id);

              case 7:
                _context.t0 = _context.sent;

                if (_context.t0) {
                  _context.next = 12;
                  break;
                }

                _context.next = 11;
                return keystore.createKey(id);

              case 11:
                _context.t0 = _context.sent;

              case 12:
                key = _context.t0;
                return _context.abrupt("return", key.public.marshal().toString('hex'));

              case 14:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function getId() {
        return _getId.apply(this, arguments);
      }

      return getId;
    }()
  }, {
    key: "signIdentity",
    value: function () {
      var _signIdentity = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(data) {
        var options,
            id,
            keystore,
            key,
            _args2 = arguments;
        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                options = _args2.length > 1 && _args2[1] !== undefined ? _args2[1] : {};
                id = options.id;

                if (id) {
                  _context2.next = 4;
                  break;
                }

                throw new Error('id is required');

              case 4:
                keystore = this._keystore;
                _context2.next = 7;
                return keystore.getKey(id);

              case 7:
                key = _context2.sent;

                if (key) {
                  _context2.next = 10;
                  break;
                }

                throw new Error("Signing key for '".concat(id, "' not found"));

              case 10:
                return _context2.abrupt("return", keystore.sign(key, data));

              case 11:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));

      function signIdentity(_x) {
        return _signIdentity.apply(this, arguments);
      }

      return signIdentity;
    }()
  }], [{
    key: "type",
    get: function get() {
      return type;
    }
  }, {
    key: "verifyIdentity",
    value: function () {
      var _verifyIdentity = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3(identity) {
        return _regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                return _context3.abrupt("return", Keystore.verify(identity.signatures.publicKey, identity.id, identity.publicKey + identity.signatures.id));

              case 1:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3);
      }));

      function verifyIdentity(_x2) {
        return _verifyIdentity.apply(this, arguments);
      }

      return verifyIdentity;
    }()
  }]);

  return OrbitDBIdentityProvider;
}(IdentityProvider);

module.exports = OrbitDBIdentityProvider;